import React, { useEffect } from "react";
import Footer from "../components/common/Footer"; 
import mkponda from "../assets/mkponda.jpg"
import { FaHome } from "react-icons/fa";
import AOS from "aos";
import 'aos/dist/aos.css'
      // icons
import { BsFillTelephoneFill } from "react-icons/bs";
import { MdOutlineAttachEmail } from "react-icons/md";
import { MdOutlineTouchApp } from "react-icons/md";
import { IoShareSocial } from "react-icons/io5";
import { TiSocialFacebook } from "react-icons/ti";
import { SlSocialInstagram } from "react-icons/sl";
import { SlSocialYoutube } from "react-icons/sl";

function Contact() {
  useEffect(()=>{
    AOS.init({duraction:2000})
  },[])
  
  return (
    <div>
      <div className="min-h-[calc(100vh-5.8rem)]   pt-4 w-11/12 mx-auto pb-4">
        <div className="text-center font-mulish font-bold lg:text-2xl md:text-2xl text-lg">Bheed Ka Hissa Nhi Karan Baniye</div>

        <div className="lg:min-h-[calc(100vh-5.8rem)] border-t mt-2 flex lg:flex-row flex-col-reverse pt-0">
          <div className="lg:w-[50%] ">
            {/* location */}
            <div className="lg:w-[60%] ml-4 mt-6" data-aos="fade-up-right">
              <div className="flex gap-4">
              <FaHome className=" text-6xl text-red " />

                <div>
                  <h2 className="font-bold text-xl font-mulish">Location</h2>
                  <div className=" font-kanit">
                  Lambakheda, Near Nabibagh,Berasia Road, 
                  Bhopal (M.P.)
                  India - 462 038
                  </div>
                </div>
              </div>
            </div>

            {/* telephone */}
            <div className="lg:w-[60%] ml-4 mt-6" data-aos="fade-up-left">
              <div className="flex gap-4">
              <BsFillTelephoneFill  className=" text-4xl text-red " />

                <div>
                  <h2 className="font-bold text-xl font-mulish">Contact</h2>
                  <div className=" font-kanit">
                  Tel.:- +91-755- 2989929, 4225901

                  Admission Helpline:- 9827078687
                  </div>
                </div>
              </div>
            </div>
            {/* email */}
            <div className="lg:w-[60%] ml-4 mt-6" data-aos="fade-up-right">
              <div className="flex gap-4">
              <MdOutlineAttachEmail  className=" text-4xl text-red " />

                <div>
                  <h2 className="font-bold text-xl font-mulish">E-Mail ID</h2>
                  <div className=" font-kanit">
                 <a href="mailto:hi@mkpondacollege.org" className=" text-blue-500 underline">hi@mkpondacollege.org</a>
                <br />
                 <a href="mailto:principal@mkpondacollege.org" className=" text-blue-500 underline">principal@mkpondacollege.org</a>
               <br />
                 <a href="mailto:director@mkpondacollege.org" className=" text-blue-500 underline">director@mkpondacollege.org</a>

                  </div>
                </div>
              </div>
            </div>
            {/* website */}
            <div className="lg:w-[60%] ml-4 mt-6" data-aos="fade-up-left">
              <div className="flex gap-4">
              <MdOutlineTouchApp  className=" text-4xl text-red " />

                <div>
                  <h2 className="font-bold text-xl font-mulish">Website</h2>
                  <div className=" font-kanit">
                 <a href="http://www.mkpondacollege.org" target="_blank" className=" text-blue-500 underline" > www.mkpondacollege.org</a>
                  </div>
                </div>
              </div>
            </div>
            {/* social media */}
            <div className="lg:w-[60%] ml-4 mt-6" data-aos="fade-up-right">
              <div className="flex gap-4">
              <IoShareSocial  className=" text-4xl text-red " />

                <div>
                  <h2 className="font-bold text-xl font-mulish">Social Media</h2>
                  <div className=" font-kanit flex gap-4 text-2xl pt-2">
                 <a href="https://www.instagram.com/mkpondacollege/" ><SlSocialInstagram /> </a>
              
                 <a href="https://www.facebook.com/mkpondacollege/?hc_location=stream" ><TiSocialFacebook /> </a>
               
                 <a href="https://www.youtube.com/@mkpondacollege" ><SlSocialYoutube /> </a>

                  </div>
                </div>
              </div>
            </div>
          </div>

        {/* Image& logos */}
          <div className="lg:w-[48%] lg:pt-10 m-3 " data-aos="zoom-in">
          <img src={mkponda} alt="" className="rounded-2xl shadow-lg shadow-red" />
        </div>
        </div>
       
      </div>
      <Footer />
    </div>
  );
}

export default Contact;
